/* Designer Consignor Naples — product.js
   PDP lightbox + sticky buy-bar. Vanilla, null-safe (no-ops off the PDP). */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---- Lightbox ---- */
  var lb = $('[data-lightbox]');
  var main = $('[data-gallery-main]');
  if (lb && main) {
    var lbImg = $('[data-lightbox-img]', lb);
    var lastFocused = null;
    function open() {
      if (lbImg) { lbImg.src = main.currentSrc || main.src; }
      lastFocused = document.activeElement;
      lb.classList.add('open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var c = $('[data-lightbox-close]', lb); if (c) c.focus();
    }
    function close() {
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }
    $all('[data-lightbox-open]').forEach(function (b) { b.addEventListener('click', open); });
    $all('[data-lightbox-close]', lb).forEach(function (b) { b.addEventListener('click', close); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('open')) close(); });
  }

  /* ---- Sticky buy-bar (shown once the main add-to-bag scrolls out of view above) ---- */
  var bar = $('[data-pdp-sticky]');
  var form = $('[data-product-form]');
  if (bar && form && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('show', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(form);
  }
})();
